import IntersectionHydrator from '@netc/intersection-hydrator';
import { registrations } from '../registrations';
// @netc/intersection-hydrator calls window.requestIdleCallback directly with no
// working fallback (its own undefined-check falls through to call it anyway), so
// browsers without native support (older Safari, some WebViews) throw during
// hydration. Polyfill before the hydrator is constructed.
window.requestIdleCallback =
    window.requestIdleCallback || ((cb) => setTimeout(cb, 1));
new IntersectionHydrator(registrations);
